import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';

// redux
import { mapDispatchProps, mapStateToProps } from '../../../../store/store';
import { connect } from 'react-redux';
import { ROUTES } from '../../../../routes';
import { useNavigate } from 'react-router';
import API from '../../../../api';

import Fetcher from '../../../../libraries/fetcher';
import ResourceOrderer from '../resourceOrderer';
import { useLanguage } from '@languages/index';

const SNSOrderYoutube = (props: any) => {
  const language = useLanguage();
  const languageTexts = { ...language.common, ...language.pages.sns };
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  // brand
  const fetchBrandRes = useQuery({
    queryKey: ['fetch_brand'],
    queryFn: async () => {
      try {
        const res = await API.Brand.show({ brandToken: props.auth.token });
        props.setBrand(res.data.brand);

        return res;
      } catch (error) {
        props.showModal({
          hideCloseButton: true,
          text: languageTexts.celeb_detail_text_1,
        });
      }
    },
  });
  if (
    fetchBrandRes.data &&
    fetchBrandRes.data.brand &&
    fetchBrandRes.data.brand.hasExperiencedSnsInstall &&
    !fetchBrandRes.data.brand.snsPassInstalledAt
  ) {
    navigate(ROUTES.SNS_PAYMENT_COMPLETE.PATH);
  }

  const countYoutubesRes = useQuery({
    queryKey: ['count_youtubes:published', fetchBrandRes.data?.brand?.id],
    queryFn: async () => {
      try {
        const res = await API.BrandSns.countYoutubes({
          brandToken: props.auth.token,
          where: { is_published: true },
        });
        return res.data.count;
      } catch (error) {
        props.showModal({
          hideCloseButton: true,
          text: languageTexts.celeb_detail_text_2,
        });
      }
    },
    enabled: !!fetchBrandRes.data,
  });

  // fetcher
  const youtubesFetcherRes = useQuery({
    queryKey: ['get_youtubes_fetcher:published', fetchBrandRes.data?.brand?.id],
    queryFn: () =>
      new Fetcher(async (offset: number, limit: number) => {
        const res = await API.BrandSns.fetchYoutubes({
          brandToken: props.auth.token,
          where: { is_published: true },
          offset,
          limit,
        });
        return res.data.reviews;
      }),
    enabled: !!fetchBrandRes.data,
  });
  const removeFetcherQueries = () => {
    queryClient.removeQueries({
      queryKey: [`get_youtubes_fetcher:published`],
      exact: false,
    });
  };

  useEffect(() => {
    return () => {
      queryClient.removeQueries({
        queryKey: ['count_youtubes:published'],
        exact: false,
      });
      removeFetcherQueries();
    };
  }, []);

  return (
    <ResourceOrderer
      resourceName={languageTexts.index_text_7}
      resourceCount={countYoutubesRes.data || 0}
      fetcher={youtubesFetcherRes.data}
      initialFetchCount={18}
      adderForMore={18}
      makeItemTagFunc={(rsrc) => (
        <div>
          <img
            className="object-cover aspect-[1.7796] w-full h-full"
            src={`http://img.youtube.com/vi/${rsrc.videoKey}/mqdefault.jpg`}
          />
        </div>
      )}
      updateOrderFunc={async (ids) => {
        const res = await API.BrandSns.orderYoutubes({
          brandToken: props.auth.token,
          ids,
        });
        removeFetcherQueries();
      }}
    />
  );
};

export default connect(mapStateToProps, mapDispatchProps)(SNSOrderYoutube);
